import React from 'react'
import AppLayout from '../../../../../layout/components/AppLayout'
import ALLLeaveRequestList from '../components/AllLeaveRequestList'

function LeaveRequestDashboardPage() {
  return (
    <AppLayout>
      <div className='container-fluid'>
        <div className='row'>
          <div className='col-md-12'>
            <ALLLeaveRequestList />
          </div>
        </div>
      </div>
    </AppLayout>
  )
}

export default LeaveRequestDashboardPage